import classNames from 'classnames';
import React from 'react';
import { Drawer, makeStyles, IconButton, Icons } from '~/lib/bn-material-ui';
import { theme as muiTheme } from '~/utility/styles/mui-theme';

const DRAWER_WIDTH = 500;

const useStyles = makeStyles<typeof muiTheme>((theme) => ({
  drawerPaper: {
    width: DRAWER_WIDTH,
    marginTop: muiTheme.spacing(7),
    padding: 16,
    backgroundColor: theme.palette.gray[0],
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));

export type BnInfoPanelClass = 'drawerPaper' | 'drawer';
export type BnInfoPanelClasses = Partial<Record<BnInfoPanelClass, string>>;

export function BnInfoPanel({ open, setOpen, content, title, classes }:
  { open: boolean, setOpen: (open: boolean) => void, content: React.ReactNode, title: React.ReactNode, classes?: BnInfoPanelClasses }) {
  const styles = useStyles();
  return (
    <Drawer
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        className: classNames(styles.drawerPaper, classes?.drawerPaper),
      }}
      className={classNames(classes?.drawer)}
      anchor='right'
      hideBackdrop
      ModalProps={{
        disableEnforceFocus: true,
        disableAutoFocus: true,
        disableRestoreFocus: true,
      }}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      <IconButton className={styles.closeButton} onClick={() => setOpen(false)} size='large'><Icons.Close /></IconButton>
      {title}
      {content}
    </Drawer>
  );
}
